import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { Auth, API } from "aws-amplify";
import { useCookies } from 'react-cookie';
import { onError } from "../libs/errorLib";
import { formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import libmime from "libmime";
import AdminLeftMenu from "./AdminLeftMenu";
import BasicDomainItems from "./BasicDomainItems";
import ExpertDomainItems from "./ExpertDomainItems";
import PrimaryGamesItems from "./PrimaryGamesItems";
import Cert2CheckItems from "./Cert2CheckItems";
import MemberTypeItemNames from "./MemberTypeItemNames";
import AdminNewMail from "./AdminNewMail";
import AdminMailConfirm from "./AdminMailConfirm";
import AdminMailComplete from "./AdminMailComplete";
import config from '../config';
import "./Admin.css";
import "../admin.css";

export default function AdminMemberships() {
//  const [fees, setFees] = useState([]);
  const [mmembers, setMmembers] = useState([]);
  const history = useHistory();

  const [refreshCounter, setRefreshCounter] = useState(0);
  const [checks, setChecks] = useState([]);
  const [selectAll, setSelectAll] = useState(0);

  const search = useLocation().search;
  let year = new URLSearchParams(search).get('y');
  if (!year) year = "2020";
  const qPage = new URLSearchParams(search).get('page'); // page
  console.log('qPage = ' + qPage);

  const qRC = new URLSearchParams(search).get('m'); // mode restore cookies

  console.log('qRC = ' + qRC);
  const [cookies, setCookie, removeCookie] = useCookies(['sParams']);

  const [pageLimit, setPageLimit] = useState((qRC != 'rc' || !cookies.sParams) ? "50" : cookies.sParams.pageLimit);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1);

  const [mailTos, setMailTos] = useState([]);
  const [renderingState, setRenderingState] = useState('Main');

  useEffect(() => {
    console.log('useEffect called...');
    console.log(cookies.sParams);
    if (qRC != 'rc' || !cookies.sParams) removeCookie('sParams');
    else {
      console.log(cookies.sParams);
      fields.mNumBegin = cookies.sParams.mNumBegin;
      fields.sJoinYBegin = cookies.sParams.sJoinYBegin;
      fields.sJoinMBegin = cookies.sParams.sJoinMBegin;
      fields.sJoinDBegin = cookies.sParams.sJoinDBegin;
      fields.sJoinYEnd = cookies.sParams.sJoinYEnd;
      fields.sJoinMEnd = cookies.sParams.sJoinMEnd;
      fields.sJoinDEnd = cookies.sParams.sJoinDEnd;
      fields.mName = cookies.sParams.mName;
      fields.mAffiliationName = cookies.sParams.mAffiliationName;
      fields.mPrefecture = cookies.sParams.mPrefecture;
      fields.mBasicDomain = cookies.sParams.mBasicDomain;
      fields.mmExpertDomain = cookies.sParams.mmExpertDomain;
      fields.mCert1Selects = cookies.sParams.mCert1Selects;
      setMTypes(cookies.sParams.mTypes);
      setMClasses(cookies.sParams.mClasses);
      setMPositions(cookies.sParams.mPositions);
      setMCommittees(cookies.sParams.mCommittees);
      setMRepresentative(cookies.sParams.mRepresentative);
      setMExpertDomainChecks(cookies.sParams.mExpertDomainChecks);
      setMCert2Checks(cookies.sParams.mCert2Checks);
      setMAnnualFees(cookies.sParams.mAnnualFees);
      setMPrimaryGamesChecks(cookies.sParams.mPrimaryGamesChecks);
      fields.sYearOfFee = cookies.sParams.sYearOfFee;
      fields.orderBy = cookies.sParams.orderBy;
      fields.ascOrDesc = cookies.sParams.ascOrDesc;
      fields.mLimit = cookies.sParams.mLimit;
      setPageLimit(pageLimit);
      setCurrentPage(cookies.sParams.currentPage);
    }
    const onLoad = async () => {
      try {
        console.log('onLoad called...');
        const anonymousUser = await Auth.currentCredentials();
        console.log(anonymousUser);
        const mc = await membersOnCondition(currentPage, false, fields.ascOrDesc);
        console.log(mc);
        setTotal(mc);    
        const ms = await membersOnCondition(currentPage, true, fields.ascOrDesc);
        console.log('onLoad ms.length:' + ms.length);
//        console.log('page count: ' + parseInt (ms.length / pageLimit));
        initializeChecks(ms.length);
        const n = parseInt(mc / pageLimit) + ( mc % pageLimit > 0 ? 1 : 0);
        console.log('page count: ' + n);

        let ps = [];
        console.log('currentPage: ' + currentPage);
        const maxp = 4 + parseInt(currentPage);
        console.log(`n=${n}, currentPage=${currentPage}, maxp=${maxp}`);
        var pnc = 0; //page num count
        var leftMost = false;
        var inTheMiddle = false;
        var rightMost = false;
        if (n > 9 && currentPage > 5) {
            ps.push({"label": '<<'});
        }
        for(let i=0; i < 9; i++) {
          if (currentPage <= 5) {
            if (!leftMost) {
              pnc = 0;
              leftMost = true;
            }
          } else if(currentPage > (n - 9) && !rightMost) {
            if (!rightMost) {
              pnc = currentPage - 9;
              rightMost = true;
            }
          } else {
            if (!inTheMiddle) {
               pnc = parseInt(currentPage) - 5;
              inTheMiddle = true;
            }
	  }
          pnc++;
          console.log('pnc: ' + pnc);
          if (pnc > n) 
            break;
          ps.push({"label": /*i+1*/pnc});
//          if (pnc >= 9) {
//            break;
//	  }
        }
        if (n > maxp) {
          ps.push({"label": '>>'});
        }
        console.log('onLoad()........ps');
        console.log(ps);
        setPages(ps);
      } catch (e) {
        onError(e);
      }
    };
    onLoad();
  },[refreshCounter]);

  const initializeChecks = (len) => {
    const n = (len < pageLimit) ? len : pageLimit;
    var arr = [];
    for (let i=0; i<n; i++) arr.push(0);
    console.log('checks arr:');
    console.log(arr);
    setChecks(arr);
    setSelectAll(0);
  };

  async function loadMembers() {
    console.log(`/members?ob=${fields.ascOrDesc}&rgs=1`);
    const ms = await API.get("sakurajima", `/members?ob=${fields.ascOrDesc}&rgs=1`); //rgs: registered
    console.log(ms);
    const l = ms.length < pageLimit ? ms.length : pageLimit;
    setChecksOnPage(ms, pageLimit, currentPage);
    setMmembers(ms);
    return ms;
  }

  const isPositionChecked = () => {
      return !(0 == mPositions[0] && 0 == mPositions[1] && 0 == mPositions[2] && 0 == mPositions[3] && 0 == mPositions[4]);
  };
    
  const isCommitteeChecked = () => {
      return !(0 == mCommittees[0] && 0 == mCommittees[1] && 0 == mCommittees[2] && 0 == mCommittees[3] && 0 == mCommittees[4] && 
        0 == mCommittees[5] && 0 == mCommittees[6] && 0 == mCommittees[7] && 0 == mCommittees[8] && 0 == mCommittees[9]
      );
  };

  const isRepresentativeChecked = () => {
      return !(0 == mRepresentative[0]);
  };

  const isExpertDomainChecked = () => {
      return !(0 == mExpertDomainChecks[0] && 0 == mExpertDomainChecks[1] && 0 == mExpertDomainChecks[2] 
        && 0 == mExpertDomainChecks[3] && 0 == mExpertDomainChecks[4] && 0 == mExpertDomainChecks[5] 
        && 0 == mExpertDomainChecks[6] && 0 == mExpertDomainChecks[7] && 0 == mExpertDomainChecks[8] 
        && 0 == mExpertDomainChecks[9] && 0 == mExpertDomainChecks[10] && 0 == mExpertDomainChecks[11] 
        && 0 == mExpertDomainChecks[12] && 0 == mExpertDomainChecks[13] && 0 == mExpertDomainChecks[14] 
        && 0 == mExpertDomainChecks[15] && 0 == mExpertDomainChecks[16] && 0 == mExpertDomainChecks[17] 
        && 0 == mExpertDomainChecks[18] && 0 == mExpertDomainChecks[19] && 0 == mExpertDomainChecks[20] 
        && 0 == mExpertDomainChecks[21]);
  };

  const isPrimaryGamesChecked = () => {
      return !(0 == mPrimaryGamesChecks[0] && 0 == mPrimaryGamesChecks[1] && 0 == mPrimaryGamesChecks[2] 
        && 0 == mPrimaryGamesChecks[3] && 0 == mPrimaryGamesChecks[4] && 0 == mPrimaryGamesChecks[5] 
        && 0 == mPrimaryGamesChecks[6] && 0 == mPrimaryGamesChecks[7] && 0 == mPrimaryGamesChecks[8]);
  };
    
  const positionChecked = (m) => {
    console.log("positionChecked memType : " + m.memType);
    if (!isPositionChecked()) return true;

    for (const i in mPositions) {
      if (mPositions[i] == 1 && m.memPost[i] == 1) return true;
    }
    return false;
  };

  const committeeChecked = (m, hit) => {
    if (!hit) return false;
    console.log("committeeChecked memType : " + m.memType);
    if (!isCommitteeChecked()) return true;

    for (const i in mCommittees) {
      if (mCommittees[i] == 1 && m.memCommittee[i] == 1) return true;
    }
    return false;
  };

  const representativeChecked = (m, hit) => {
    if (!hit) return false;
    console.log("representativeChecked memType : " + m.memType);
    if (!isRepresentativeChecked()) return true;

    if (mRepresentative[0] == 1 && m.memRepresentative[0] == 1) return true;
    return false;
  };

  const expertDomainChecked = (m, hit) => {
    if (!hit) return false;
    console.log("expertDomainChecked memType : " + m.memType);
    if (!isExpertDomainChecked()) return true;

    for (const i in mExpertDomainChecks) {
      if (mExpertDomainChecks[i] == 1 && m.expertDomains[i] == 1) return true;
    }
    return false;
  };

  const primaryGamesChecked = (m, hit) => {
    if (!hit) return false;
    console.log("primaryGamesChecked memType : " + m.memType);
    if (!isPrimaryGamesChecked()) return true;

    if (mPrimaryGamesChecks[0] == 1 && m.primaryGames == 1) return true;
    if (mPrimaryGamesChecks[1] == 1 && m.primaryGames == 2) return true;
    if (mPrimaryGamesChecks[2] == 1 && m.primaryGames == 3) return true;
    if (mPrimaryGamesChecks[3] == 1 && m.primaryGames == 4) return true;
    if (mPrimaryGamesChecks[4] == 1 && m.primaryGames == 11) return true;
    if (mPrimaryGamesChecks[5] == 1 && m.primaryGames == 12) return true;
    if (mPrimaryGamesChecks[6] == 1 && m.primaryGames == 13) return true;
    if (mPrimaryGamesChecks[7] == 1 && m.primaryGames == 14) return true;
    if (mPrimaryGamesChecks[8] == 1 && m.primaryGames == 21) return true;
    return false;
  };

  const cert1Selected = (m, hit) => {
    console.log('cert1Selected hit = ' + hit);
    if (!hit) return false;
    console.log('fields.mCert1Selects = ' + fields.mCert1Selects);
    console.log(m.cert1Checks);
    if (fields.mCert1Selects != 0) {
      let f = false;
        switch(fields.mCert1Selects) {
        case "1":
          if (m.cert1Checks[0] != 0) f = true;
	  break;
        case "2":
          if (m.cert1Checks[1] != 0) f = true;
	  break;
        case "3":
          if (m.cert1Checks[2] != 0) f = true;
	  break;
        case "4":
          if (m.cert1Checks[3] != 0) f = true;
	  break;
        case "5":
          if (m.cert1Checks[4] != 0) f = true;
	  break;
        case "6":
          if (m.cert1Checks[5] != 0) f = true;
	  break;
        default:
          f = true;
	  break;
        }
        return f;
     }
     return true;
  };

  const isCert2Checked = () => {
    return (!(
            0 == mCert2Checks[0] && 0 == mCert2Checks[1] && 0 == mCert2Checks[2] && 0 == mCert2Checks[3] &&
            0 == mCert2Checks[4] && 0 == mCert2Checks[5] && 0 == mCert2Checks[6] && 0 == mCert2Checks[7] &&
            0 == mCert2Checks[8] && 0 == mCert2Checks[9] && 0 == mCert2Checks[10] && 0 == mCert2Checks[11] &&
            0 == mCert2Checks[12] && 0 == mCert2Checks[13] && 0 == mCert2Checks[14])
           );
  };

  const cert2Checked = (m, hit) => {
    if (!hit) return false;
    console.log("cert2Checked memType : " + m.memType);
    if ((
            0 == mCert2Checks[0] && 0 == mCert2Checks[1] && 0 == mCert2Checks[2] && 0 == mCert2Checks[3] &&
            0 == mCert2Checks[4] && 0 == mCert2Checks[5] && 0 == mCert2Checks[6] && 0 == mCert2Checks[7] &&
            0 == mCert2Checks[8] && 0 == mCert2Checks[9] && 0 == mCert2Checks[10] && 0 == mCert2Checks[11] &&
            0 == mCert2Checks[12] && 0 == mCert2Checks[13] && 0 == mCert2Checks[14])
       ) 
      return true;
    console.log(mCert2Checks);
    for (const i in mCert2Checks) {
      if (mCert2Checks[i] == 1 && m.cert2Checks[i] == 1) return true;
    }
    return false;
  };

  async function membersOnCondition(cp, isLoad, ob) {
    console.log('membersOnCondition...');
    let p = `ob=${ob}&rgs=1&cp=${cp}&pl=${pageLimit}`;
    let isMNumFilterd = false;
    if (fields.mNumBegin) {
      p += `&bn=${fields.mNumBegin}`;
      isMNumFilterd = true;
    }
    if (fields.mNumEnd) {
      p += `&en=${fields.mNumEnd}`;
        isMNumFilterd = true;
    }
    if (fields.sJoinYBegin != '0000') {
      const m = fields.sJoinMBegin == '00' ? '01' : fields.sJoinMBegin;
      const d = fields.sJoinDBegin == '00' ? '01' : fields.sJoinDBegin;
      p += `&jds=${fields.sJoinYBegin}/${m}/${d}`;
    }
    if (fields.sJoinYEnd != '0000') {
      const m = fields.sJoinMEnd == '00' ? '01' : fields.sJoinMEnd;
      const d = fields.sJoinDEnd == '00' ? '01' : fields.sJoinDEnd;
      p += `&jde=${fields.sJoinYEnd}/${m}/${d}`;
    }
    if (fields.mName)
      p += `&na=${fields.mName}`;

    if (fields.mAffiliationName)
      p += `&afn=${fields.mAffiliationName}`;

    if (fields.mPrefecture) {
      p += `&prf=${fields.mPrefecture}`;
      console.log('prefecture = ' + fields.mPrefecture);
    }

    if (!(0 == mTypes[0] && 0 == mTypes[1] && 0 == mTypes[2] && 0 == mTypes[3] && 0 == mTypes[4] && 0 == mTypes[5] && 0 == mTypes[6] && 0 == mTypes[7])) 
      p += `&mtp=${mTypes.join()}`;


    if (!(0 == mClasses[0] && 0 == mClasses[1] && 0 == mClasses[2] && 0 == mClasses[3])) 
      p += `&mcls=${mClasses.join()}`;

    if (fields.mBasicDomain != 0) {
      p += `&mbd=${fields.mBasicDomain}`;
    }

    if (fields.mExpertDomain != 0) {
      p += `&med=${fields.mExpertDomain}`;
    }

    if (fields.mCert1Selects != 0) {
      p += `&mct1=${fields.mCert1Selects}`;
    }

    if (fields.mDegree) {
      p += `&mdgr=${fields.mDegree}`;
    }

    if (isRepresentativeChecked()) {
      p += `&repr=1`;
    }

    if (isPositionChecked()) {
      p += `&mpst=${mPositions.join()}`;
    }

    if (isCommitteeChecked()) {
      p += `&mcmm=${mCommittees.join()}`;
    }

    if (isExpertDomainChecked()) {
      p += `&expd=${mExpertDomainChecks.join()}`;
    }

    if (isPrimaryGamesChecked()) {
      p += `&prmg=${mPrimaryGamesChecks.join()}`;
    }

    if (isCert2Checked()) {
      p += `&crt2=${mCert2Checks.join()}`;
    }

//    if (!(
//        0 == mCert2Checks[0] && 0 == mCert2Checks[1] && 0 == mCert2Checks[2] && 0 == mCert2Checks[3] &&
//        0 == mCert2Checks[4] && 0 == mCert2Checks[5] && 0 == mCert2Checks[6] && 0 == mCert2Checks[7] &&
//        0 == mCert2Checks[8] && 0 == mCert2Checks[9] && 0 == mCert2Checks[10] && 0 == mCert2Checks[11]
//       )) 
//      p += `&mct2=${mCert2Checks.join()}`;

    const myUrl = isLoad ? '/members' : '/countMembers';
    const path = p.length > 0 ? `${myUrl}?${p}` : myUrl;
    console.log(path);
    const ms = await API.get("sakurajima", path);
    console.log(ms);
    if (!isLoad) return ms;
    let ums = [];
    for(let i=0; i < ms.length; i++) {
      const m = ms[i];
      if (isMNumFilterd && 'NotAssignedYet' == m.data) continue;
      let hit = true;
//      hit = positionChecked(m);
//      hit = committeeChecked(m, hit);
//      hit = representativeChecked(m, hit);
//      hit = expertDomainChecked(m, hit);
//      hit = primaryGamesChecked(m, hit);
//      hit = cert1Selected(m, hit);
//      hit = cert2Checked(m, hit);
      console.log('field.mCert1Selects = ' + fields.mCert1Selects);
/*      if (fields.mCert1Selects != 0) {
        switch(fields.mCert1Selects) {
        case "1":
          if (m.cert1Checks[0] != 0) hit = true;
	  break;
        case "2":
          if (m.cert1Checks[1] != 0) hit = true;
	  break;
        case "3":
          if (m.cert1Checks[2] != 0) hit = true;
	  break;
        case "4":
          if (m.cert1Checks[3] != 0) hit = true;
	  break;
        case "5":
          if (m.cert1Checks[4] != 0) hit = true;
	  break;
        default:
	  break;
        }
      } else { if (!hit) hit = true; } */
      console.log('hit = ' + hit);
      if (!hit) continue;
      ums.push(m);
    }
    setMmembers(ums);
    return ums;
  }

  const { userProfile } = useAppContext();

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    mNumBegin: "",
    mNumEnd: "",
    sJoinYBegin: "0000",
    sJoinMBegin: "00",
    sJoinDBegin: "00",
    sJoinYEnd: "0000",
    sJoinMEnd: "00",
    sJoinDEnd: "00",
    mName:"",
    mAffiliationName: "",
    mPrefecture: "",
    mBasicDomain: "0",
    mExpertDomain: "0",
    mCert1Selects: "0",
    mDegree: "",
    sYearOfFee: "",
    orderBy: "1",
    ascOrDesc: "1",
    mLimit: "50",
    updateStatus: "0",
    subject:"",
    mailBody:"",
  },
  {
    mNumBegin: {n:"", f: (value) => { return '' }},
    mNumEnd: {n:"", f: (value) => { return '' }},
    sJoinYBegin: {n:"", f: (value) => { return '' }},
    sJoinMBegin: {n:"", f: (value) => { return '' }},
    sJoinDBegin: {n:"", f: (value) => { return '' }},
    sJoinYEnd: {n:"", f: (value) => { return '' }},
    sJoinMEnd: {n:"", f: (value) => { return '' }},
    sJoinDEnd: {n:"", f: (value) => { return '' }},
    mName: {n:"", f: (value) => { return '' }},
    mAffiliationName: {n:"", f: (value) => { return '' }},
    mPrefecture: {n:"", f: (value) => { return '' }},
    mBasicDomain: {n:"", f: (value) => { return '' }},
    mExpertDomain: {n:"", f: (value) => { return '' }},
    mCert1Selects: {n:"", f: (value) => { return '' }},
    mDegree: {n:"", f: (value) => { return '' }},
    sYearOfFee: {n:"", f: (value) => { return '' }},
    orderBy: {n:"", f: (value) => {  return '' }},
    ascOrDesc: {n:"", f: (value) => { return '' }},
    mLimit: {n:"", f: (value) => { return '' }},
    updateStatus: {n:"", f: (value) => { return '' }},
    subject: {n:"", f: (value) => { console.log(value); return '' }},
    mailBody: {n:"", f: (value) => { console.log(value); return '' }},
  });

  // mTypes checkbox
  const [mTypes, setMTypes] = useState([0,0,0,0,0,0,0,0]);
  // mClasses checkbox
  const [mClasses, setMClasses] = useState([0,0,0,0]);
  // mPositions checkbox
  const [mPositions, setMPositions] = useState([0,0,0,0,0]);
  // mCommittees checkbox
  const [mCommittees, setMCommittees] = useState([0,0,0,0,0,0,0,0,0,0]);
  // mCommittees checkbox
  const [mRepresentative, setMRepresentative] = useState([0]);
  // mCert2Checks checkbox
  const [mCert2Checks, setMCert2Checks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
  // mAnnualFees checkbox
  const [mAnnualFees, setMAnnualFees] = useState([0,0]);

  // mExpertDomainChecks checkbox
  const [mExpertDomainChecks, setMExpertDomainChecks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
  // primary games checkbox
  const [mPrimaryGamesChecks, setMPrimaryGamesChecks] = useState([0,0,0,0,0,0,0,0,0]);
  const [total, setTotal] = useState(0);

  const updateCookies = (cp) => {
    console.log('updateCookies on page: ' + cp);
    const sparams = { 
      "mNumBegin": fields.mNumBegin,
      "sJoinYBegin": fields.sJoinYBegin,
      "sJoinMBegin": fields.sJoinMBegin,
      "sJoinDBegin": fields.sJoinDBegin,
      "sJoinYEnd": fields.sJoinYEnd,
      "sJoinMEnd": fields.sJoinMEnd,
      "sJoinDEnd": fields.sJoinDEnd,
      "mName": fields.mName,
      "mAffiliationName": fields.mAffiliationName,
      "mPrefecture": fields.mPrefecture,
      "mBasicDomain": fields.mBasicDomain,
      "mmExpertDomain": fields.mmExpertDomain,
      "mCert1Selects": fields.mCert1Selects,
      "mTypes": mTypes,
      "mClasses": mClasses,
      "mPositions": mPositions,
      "mCommittees": mCommittees,
      "mRepresentative": mRepresentative,
      "mExpertDomainChecks": mExpertDomainChecks,
      "mCert2Checks": mCert2Checks,
      "mAnnualFees": mAnnualFees,
      "mPrimaryGamesChecks": mPrimaryGamesChecks,
      "sYearOfFee": fields.sYearOfFee,
      "orderBy": fields.orderBy,
      "ascOrDesc": fields.ascOrDesc,
      "mLimit": fields.mLimit,
      "pageLimit": pageLimit,
      "currentPage": cp,
    };
    console.log(sparams);
    setCookie('sParams', sparams); 
  }

  async function handleSearch(event) {
    console.log('handleSearch...');
    console.log(fields.orderBy);
    console.log(fields.ascOrDesc);
    const firstPage = 1;
    setCurrentPage(firstPage);
    updateCookies(firstPage);
    try {
      const mc = await membersOnCondition(firstPage, false, fields.ascOrDesc);
      console.log('seaarch count: ' + mc);
      setTotal(mc);    
      const ms = await membersOnCondition(firstPage, true, fields.ascOrDesc);
      console.log('search ms.length:' + ms.length);
      initializeChecks(ms.length);
      const n = parseInt (mc / pageLimit) + ( mc % pageLimit > 0 ? 1 : 0);
      console.log(n);
      let ps = [];
      console.log('currentPage: ' + currentPage);
/*
      var pnc = 0; //page num count
      var showLeft = false;
      for(let i=0; i < n; i++) {
        if (n > 9) {
          if (i < firstPage-1) continue;
          if (firstPage > 1 && !showLeft) { ps.push({"label": '<<'}); showLeft = true; }
	}
        pnc++;
        ps.push({"label": i+1});
        if (pnc > 9) {
          ps.push({"label": '>>'});
          break;
        }
      }
      console.log(ps);
      setPages(ps);
*/
      setCurrentPage(1);
      setRefreshCounter(refreshCounter+1);

    } catch (e) {
      onError(e);
    }
  }

  function handleView(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/members/${pk}?vm=af&reff=mm&amd=mgmt`); // view mode is Admin Fees
  }

  function handleViewReports(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    const i = e.target.getAttribute('keyIndex');
    console.log('i = ' + i);
    console.log('pk = ' + pk);
    const ar = pk.split('#');
    history.push(`/admin/reports?mid=${ar[0]}&y=${ar[1]}`);
  }

 function handleEdit(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/editMembers/${pk}?reff=mm&amd=mgmt`);
 }

async function handleInvitation(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    const idx = e.target.getAttribute('idx');
    const m = mmembers[idx];
    console.log(m);
    console.log(idx);
    if ((!m.data || m.data == "NotAssignedYet")) {
        onError('会員番号が登録されていません');
	return;
    }

    const name = `${m.familyName}${m.givenName} `;

    console.log(config.mail.invitationBody.toString());
    if (!window.confirm(name + '様宛に招待メールを' + (m.authStatus=='Invited' ? '再' : '') + '送信します。よろしいですか?')) return;
    const b = config.mail.invitationBody.toString().match(/(?:\/\*(?:[\s\S]*?)\*\/)/).pop().replace(/^\/\*/, "").replace(/\*\/$/, "");
    console.log(config.mail.invitationBody.toString());

    let myUrl = `${config.url}/spw?i=${pk}&mi=${m.data}`;
    myUrl += m.memType == 3 ? '' : '&m=am';
    const ba = b.replaceAll('{{name}}', name).replaceAll('{{memType}}', (m.memType == 3 ? '正会員' : '准社員')).replaceAll('{{url}}', myUrl).replaceAll('{{}}', "\n").split("\n");
    console.log(b.replaceAll('{{name}}', name).replaceAll('{{url}}', `${config.url}/spw?i=${pk}`));
    console.log(config.mail.invitationMailSubject);

    console.log(ba);
    let bod = [];
    for (let i in ba) {
      bod.push(ba[i].trim());
    }

    console.log(bod.join("\n"));
    try {
    const subj = config.mail.invitationMailSubject.replaceAll('{{mTypeName}}', MemberTypeItemNames[m.memType]);
    let fromName = '【日本臨床スポーツ医学会】';
    const dests = [];
    dests.push({
      pk:m.pk,
      familyName:fields.familyName,
      givenName:fields.givenName,
      familyNameKana:fields.familyNameKana,
      givenNameKana:fields.givenNameKana,
      memberId:m.memberId,
      affiliationName:fields.affiliationName,
      affiliationEmail:fields.affiliationEmail,
      admissionDate:m.admissionDate,
      updatedAt:m.updatedAt,
    });

    fromName = libmime.encodeWord(fromName, 'Q');
    const r = await sendMail({
	subject: subj,
	from: fromName + ' <' + config.mail.source + '>',
	to: m.affiliationEmail,
        dests: dests,
	mailBody:bod.join("\n"),
	pk:pk,
        type: "invitation",
        memberId: m.data,
        enableLog: false,
        fromEmail: config.mail.source,
        fromName: '【日本臨床スポーツ医学会】'
    });
    console.log(r);
    if (r.statusCode == 200) {
      alert('招待メールを送信しました。');
      const ibid = `invitationBtn-${idx}`;
      console.log('invite button ID: ' + ibid);
      const el = document.getElementById(ibid);
      console.log(el);
      el.classList.add('Invited');
    } else if (r.statusCode == 500) {
      alert(r.body);
    } else {
      onError('招待メールを送信中にエラーが発生しました。');
    }
    } catch(e) {
	onError(e);
    }

 }

 function handleMTypesChange(event) {
    const n = event.target.name;
//    console.log(n.substring('mCommittees'.length));
    const i = parseInt(n.substring('mTypes'.length));
    let chs = JSON.parse(JSON.stringify(mTypes));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMTypes(chs);
  }

  function handleMClassesChange(event) {
    console.log('handleMClassesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mClasses'.length));
    let chs = JSON.parse(JSON.stringify(mClasses));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMClasses(chs);
  }

  function handleMPositionsChange(event) {
    console.log('handleMPositionsChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mPositions'.length));
    let chs = JSON.parse(JSON.stringify(mPositions));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMPositions(chs);
  }

  function handleMCommitteesChange(event) {
    console.log('handleMCommitteesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mCommittees'.length));
    let chs = JSON.parse(JSON.stringify(mCommittees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMCommittees(chs);
  }

  function handleMRepresentativeChanges(event) {
    console.log('handleMRepresentative..');
    const n = event.target.name;
    const i = parseInt(n.substring('mRepresentative'.length));
    let chs = JSON.parse(JSON.stringify(mRepresentative));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMRepresentative(chs);
  }

  function handleMAnnualFeesChange(event) {
    console.log('handleMAnnualFeesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mAnnualFees'.length));
    let chs = JSON.parse(JSON.stringify(mAnnualFees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMAnnualFees(chs);
  }

  function handleCert2ChecksChange(event) {
    console.log('handleCert2ChecksChange..');
    const n = event.target.name;
    const i = n.substring('mCert2Checks'.length);
    let chs = JSON.parse(JSON.stringify(mCert2Checks));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMCert2Checks(chs);
  }

  const handlePageChanged = async (e) => {
    console.log('handlePageChanged=>' + e.target.value);
    //handleFieldChange(e);
    setChecksOnPage(mmembers, e.target.value, currentPage);
    setPageLimit(e.target.value);
    const n = parseInt (mmembers.length / pageLimit) + ( mmembers.length % pageLimit > 0 ? 1 : 0);
    console.log(n);
    let ps = [];
    for(let i=0; i < n; i++) ps.push({"label": i+1});
    console.log(ps);
    setPages(ps);
  };

  function sendTestMail() {
    const from = {
      "email": "ito@inframe.jp",
      "name": "=?UTF-8?Q?=E3=80=90=E6=97=A5=E6=9C=AC=E8=87=A8=E5=BA=8A=E3=82=B9=E3=83=9D=E3=83=BC=E3=83=84=E5=8C=BB=E5=AD=A6=E4=BC=9A=E3=80=91?=" 
    }

    const body = {
      "from": from,
      "subject": "テストメール",
      "textPart": "メールのテストです"
    };

    const ep = "https://app.engn.jp/api/v1";
    const tk = "ODc5YjcxMzFkOThiYTlhOGY0NzE2ODg1YzkzYTIxZTNkZmVlNzllM2VlYjU1YWM4YzVhNzYzODBjYTRkOGUxYg==";
    const p = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', ep + '/deliveries/bulk/begin', true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader("Authorization", "Bearer " + tk);
      xhr.addEventListener('load', (e) => resolve(xhr));
      xhr.send(JSON.stringify(body));
    });
    return p;
  }

  async function testMail(event) {
    console.log('testMail...');
    let ids = [];
    const mIdx = (currentPage-1) * pageLimit;
    for (let i = 0, idx = mIdx; i < checks.length; i++, idx++) {
      if (checks[i] == 1) {
        console.log('### update: i ' + i + ', idx:' + idx);
        ids.push(i);
      }
      }
    console.log(ids);
    const xhr = await sendTestMail();
    console.log(xhr.response);
  }

  function handleMail(event) {
    console.log('handleMail...');

    let ids = [];
    const mIdx = (currentPage-1) * pageLimit;
    for (let i = 0, idx = mIdx; i < checks.length; i++, idx++) {
      if (checks[i] == 1) {
        console.log('### update: i ' + i + ', idx:' + idx);
        ids.push(i);
      }
    }
    console.log(ids);
    if (0 === ids.length) { onError('項目を選択して下さい。'); return; }
    setMailTos(ids);
    setRenderingState('NewMail');
  }

  async function handleClear(evenat) {
    console.log('handleClear...');
//    setMStatus([0,0,0,0,0]);

    fields.mNumBegin = '';
    fields.mNumEnd = '';
    fields.sJoinYBegin = "0000";
    fields.sJoinMBegin = "00";
    fields.sJoinDBegin = "00";
    fields.sJoinYEnd = "0000";
    fields.sJoinMEnd = "00";
    fields.sJoinDEnd = "00";
    fields.mName = "";
    fields.mAffiliationName = "";
    fields.mPrefecture = "";
    fields.mBasicDomain = "0";
    fields.mmExpertDomain = "0";
    fields.mCert1Selects = "0";
    setMTypes([0,0,0,0,0,0,0,0]);
    setMClasses([0,0,0,0]);
    setMPositions([0,0,0,0,0]);
    setMCommittees([0,0,0,0,0,0,0,0,0,0]);
    setMRepresentative([0]);
    setMExpertDomainChecks([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
    setMCert2Checks([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
    setMAnnualFees([0,0]);
    setMPrimaryGamesChecks([0,0,0,0,0,0,0,0,0]);
    fields.sYearOfFee  = "0000";
    fields.orderBy = "1";
    fields.ascOrDesc = "1";
    fields.mLimit = "50";
    setPageLimit("50");
    setRefreshCounter(refreshCounter+1);
  }

  const getStatusName = (state) => {
      if (1 == state)
	  return '入金済';
      else
	  return '未入金';
  };

  const getMemberId = (data) => {
//    const d = data.split('#');
//    return d[1];
      return data.memberId;
  };

  const handleItemCheckChanged = (e) => {
    console.log('handleItemCheckChanged...');
    console.log(e.target);
    console.log(checks);
    let chs = JSON.parse(JSON.stringify(checks));
    if ('selectAll' === e.target.name) {
      for(let i=0; checks.length > i; i++) {
        chs[i] = e.target.checked ? 1 : 0;
      }
      setChecks(chs);
      setSelectAll(e.target.checked ? 1 : 0);
      return;
    }
    console.log(e.target.value);
    setSelectAll(0);
    chs[e.target.value - (currentPage-1) * pageLimit] = e.target.checked ? 1 : 0;
    setChecks(chs);
  };

  function setChecksOnPage(ms, limit, currPg) {
    const pl = parseInt (ms.length / limit) + ( ms.length % limit > 0 ? 1 : 0);
    let n = limit * currPg;
    console.log('#### n:' + n);
    n = ms.length < n ? parseInt(ms.length / limit) : limit; // page length
    console.log('#### pl:' + pl);
    console.log('#### currentPage:' + currPg);
    console.log('#### n:' + n);
    const a = [];
    for(let i=0; i < n; i++) a.push("0");
    console.log('#### n:' + JSON.stringify(a));
    console.log('## : call setCheck');
    setChecks(a);
  }

  function updateAnnualFeeStatus(statuses) {
    console.log(statuses);
    return API.put("sakurajima", "/annualFeeStatuses", {
	body: statuses
    });
  }

  const pageClickAction = (e) => {
    e.preventDefault();
    setSelectAll(0);
    console.log('pageClick');
    console.log(currentPage);
    const idxLabel = e.target.href.split('#')[1];
    console.log(`indexLabel=${idxLabel}`);
    var curp = "1";
    console.log(parseInt(currentPage) + 5);
    if (idxLabel == '>>' || idxLabel== '%3E%3E')
	curp = (parseInt(currentPage) + 10).toString();
    else if (idxLabel == '<<' || idxLabel == '%3C%3C')
	curp = ((parseInt(currentPage) - 10) > 0 ? (parseInt(currentPage) - 10) : 1).toString();
    else 
      curp = idxLabel;
    console.log(typeof curp);
    updateCookies(curp);
//    const curp = e.target.href.split('#')[1];
    setChecksOnPage(mmembers, pageLimit, curp);
    setCurrentPage(curp);
    setRefreshCounter(refreshCounter+1);
    return false;
  };

  const sendMail = (data) => {
    return API.post('sakurajima', '/sendmail', {
      body: data
    });
  };

  const sendBulkMail = (data) => {
    return API.post('sakurajima', '/sendBulkMail2', {
      body: data
    });
  };

  function backFromMail(event) {
    console.log('backFromMail');
    if (event.target.id == "backToList")
      setRenderingState('Main');
    else
      setRenderingState('NewMail');
  }

  function handleExpertDomainChecksChange(event) {
    console.log('handleExpertDomainChecksChange...');
    console.log(event.target.checked + ',' + event.target.value);
    console.log(event.target.id);
    const i = parseInt(event.target.id.substring('expertDomainChecks'.length));
    console.log(i);
    let chs = JSON.parse(JSON.stringify(mExpertDomainChecks));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMExpertDomainChecks(chs);
  }

  function handlePrimaryGamesChecksChange(event) {
    console.log('handlePrimaryGamesChecksChange...');
    const i = parseInt(event.target.id.substring('primaryGamesChecks'.length));
    console.log(i);
    let chs = JSON.parse(JSON.stringify(mPrimaryGamesChecks));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMPrimaryGamesChecks(chs);
  }

  const handleMailSubmit = async (e) => {
    console.log("handleMailSubmit..." + e.target.id);
    if (e.target.id == 'confirm') {
      if (!fields.subject) { onError("メールのタイトルを入力してください。"); return; }
      if (!fields.mailBody) { onError("メールの本文を入力してください。"); return; }
      setRenderingState('MailConfirm');
    } else {

        if (!window.confirm('配信先一覧宛にメールを送信します。よろしいですか?')) return;
	try {
	    let to = [];
	    let dests = [];
            for (const i of mailTos) {
                to.push(mmembers[i].affiliationEmail);
                dests.push({
                  pk:mmembers[i].pk,
                  familyName:mmembers[i].familyName,
                  givenName:mmembers[i].givenName,
                  familyNameKana:mmembers[i].familyNameKana,
                  givenNameKana:mmembers[i].givenNameKana,
                  memberId:mmembers[i].memberId,
                  affiliationName:mmembers[i].affiliationName,
                  affiliationEmail:mmembers[i].affiliationEmail,
                  admissionDate:mmembers[i].admissionDate,
                  updatedAt:mmembers[i].updatedAt,
                });
	    }

            let fromName = '【日本臨床スポーツ医学会】';
            fromName = libmime.encodeWord(fromName, 'Q');
            const m = await sendBulkMail({
		subject: fields.subject,
		mailBody: fields.mailBody,
		to: to,
                dests: dests,
                from: fromName + ' <' + config.mail.source + '>',
                fromEmail: config.mail.source,
                fromName: "【日本臨床スポーツ医学会】",
                enableLog: true
	    });
            fields.subject = "";
            fields.mailBody = "";
            setRenderingState('MailSent');
	} catch (e) {
	    onError(e);
	}
    }
  };

  function renderMailComplete() {
    return (
      <AdminMailComplete
        backFromMail={backFromMail}
      />
    );
  }

  function renderMail() {
    console.log('in renderMail:');
    console.log(mmembers);
    return (
      <AdminNewMail
        members={mmembers}
        fields={fields}
        handleFieldChange={handleFieldChange}
        handleMailSubmit={handleMailSubmit}
        backFromMail={backFromMail}
        mailTos={mailTos}
      />
    );
  }

  function renderMailConfirm() {
    return (
      <AdminMailConfirm
        members={mmembers}
        fields={fields}
        handleMailSubmit={handleMailSubmit}
        backFromMail={backFromMail}
        mailTos={mailTos}
      />
    );
  }

  function renderMain() {
    return (
              <section id="contents" className="top">
                <h2>会員管理</h2>
                <div id="search">
                  <h3>条件検索</h3>
                  <Table>
                    <tbody>
                      <tr>
                        <th>会員番号</th>
                        <td>
                          <Form.Group controlId="mNumBegin" className="inlineFormControl" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mNumBegin}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>

                          <Form.Group controlId="mNumEnd" className="glbHidden inlineFormControl" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mNumEnd}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>入会日</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sJoinYBegin" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sJoinYBegin"
                              value={fields.sJoinYBegin}
                              onChange={handleFieldChange}
                            >
                              <option value="0000"></option>
                              <option value="1990">1990</option>
                              <option value="1991">1991</option>
                              <option value="1992">1992</option>
                              <option value="1993">1993</option>
                              <option value="1994">1994</option>
                              <option value="1995">1995</option>
                              <option value="1996">1996</option>
                              <option value="1997">1997</option>
                              <option value="1998">1998</option>
                              <option value="1999">1999</option>
                              <option value="2000">2000</option>
                              <option value="2001">2001</option>
                              <option value="2002">2002</option>
                              <option value="2003">2003</option>
                              <option value="2004">2004</option>
                              <option value="2005">2005</option>
                              <option value="2006">2006</option>
                              <option value="2007">2007</option>
                              <option value="2008">2008</option>
                              <option value="2009">2009</option>
                              <option value="2010">2010</option>
                              <option value="2011">2011</option>
                              <option value="2012">2012</option>
                              <option value="2013">2013</option>
                              <option value="2014">2014</option>
                              <option value="2015">2015</option>
                              <option value="2016">2016</option>
                              <option value="2017">2017</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                            </Form.Control>
                          </Form.Group> 年
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sJoinMBegin" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sJoinMBegin"
                              value={fields.sJoinMBegin}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </Form.Control>
                          </Form.Group> 月
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="sJoinDBegin" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sJoinDBegin"
                              value={fields.sJoinDBegin}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                              <option value="24">24</option>
                              <option value="25">25</option>
                              <option value="26">26</option>
                              <option value="27">27</option>
                              <option value="28">28</option>
                              <option value="29">29</option>
                              <option value="30">30</option>
                              <option value="31">31</option>
                            </Form.Control>
                          </Form.Group> 日 〜　
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sJoinYEnd" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sJoinYEnd"
                              value={fields.sJoinYEnd}
                              onChange={handleFieldChange}
                            >
                              <option value="0000"></option>
                              <option value="1990">1990</option>
                              <option value="1991">1991</option>
                              <option value="1992">1992</option>
                              <option value="1993">1993</option>
                              <option value="1994">1994</option>
                              <option value="1995">1995</option>
                              <option value="1996">1996</option>
                              <option value="1997">1997</option>
                              <option value="1998">1998</option>
                              <option value="1999">1999</option>
                              <option value="2000">2000</option>
                              <option value="2001">2001</option>
                              <option value="2002">2002</option>
                              <option value="2003">2003</option>
                              <option value="2004">2004</option>
                              <option value="2005">2005</option>
                              <option value="2006">2006</option>
                              <option value="2007">2007</option>
                              <option value="2008">2008</option>
                              <option value="2009">2009</option>
                              <option value="2010">2010</option>
                              <option value="2011">2011</option>
                              <option value="2012">2012</option>
                              <option value="2013">2013</option>
                              <option value="2014">2014</option>
                              <option value="2015">2015</option>
                              <option value="2016">2016</option>
                              <option value="2017">2017</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                            </Form.Control>
                          </Form.Group> 年
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sJoinMEnd" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sJoinMEnd"
                              value={fields.sJoinMEnd}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </Form.Control>
                          </Form.Group> 月
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="sJoinDEnd" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sJoinDEnd"
                              value={fields.sJoinDEnd}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                              <option value="24">24</option>
                              <option value="25">25</option>
                              <option value="26">26</option>
                              <option value="27">27</option>
                              <option value="28">28</option>
                              <option value="29">29</option>
                              <option value="30">30</option>
                              <option value="31">31</option>
                            </Form.Control>
                          </Form.Group> 日
                        </td>
                      </tr>
                      <tr>
                        <th>氏名</th>
                        <td>
                          <Form.Group controlId="mName" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mName}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>所属</th>
                        <td>
                          <Form.Group controlId="mAffiliationName" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mAffiliationName}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>会員種別</th>
                        <td>
                          <Form.Group size="sm" className="searchChecks">
                            <Form.Check
                              inline
                              label="正会員"
                              type="checkbox"
                              name="mTypes0"
                              value="1"
                              checked={ 1 == mTypes[0] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="正会員（准会員より移行）"
                              type="checkbox"
                              name="mTypes1"
                              value="1"
                              checked={ 1 == mTypes[1] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="准会員"
                              type="checkbox"
                              name="mTypes2"
                              value="1"
                              checked={ 1 == mTypes[2] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="申請（准会員から正会員）"
                              type="checkbox"
                              name="mTypes3"
                              value="1"
                              checked={ 1 == mTypes[3] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="名誉会員"
                              type="checkbox"
                              name="mTypes4"
                              value="1"
                              checked={ 1 == mTypes[4] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="寄贈"
                              type="checkbox"
                              name="mTypes5"
                              value="1"
                              checked={ 1 == mTypes[5] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="購読者"
                              type="checkbox"
                              name="mTypes6"
                              value="1"
                              checked={ 1 == mTypes[6] }
                              onChange={handleMTypesChange}
                            />
                            <Form.Check
                              inline
                              label="学生会員"
                              type="checkbox"
                              name="mTypes7"
                              value="1"
                              checked={ 1 == mTypes[7] }
                              onChange={handleMTypesChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr className="">
                        <th>会員区分</th>
                        <td>
                          <Form.Group size="sm" className="searchChecks">
                            <Form.Check
                              inline
                              label="現在会員"
                              type="checkbox"
                              name="mClasses0"
                              value="1"
                              checked={ 1 == mClasses[0] }
                              onChange={handleMClassesChange}
                            />
                            <Form.Check
                              inline
                              label="退会"
                              type="checkbox"
                              name="mClasses1"
                              value="1"
                              checked={ 1 == mClasses[1] }
                              onChange={handleMClassesChange}
                            />
                            <Form.Check
                              inline
                              label="退会（物故）"
                              type="checkbox"
                              name="mClasses2"
                              value="1"
                              checked={ 1 == mClasses[2] }
                              onChange={handleMClassesChange}
                            />
                            <Form.Check
                              inline
                              label="退会（除名）"
                              type="checkbox"
                              name="mClasses3"
                              value="1"
                              checked={ 1 == mClasses[3] }
                              onChange={handleMClassesChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr className="">
                        <th>役職（正会員）</th>
                        <td>
                          <Form.Group size="sm" className="searchChecks">
                            <Form.Check
                              inline
                              label="理事長"
                              type="checkbox"
                              name="mPositions0"
                              value="1"
                              checked={ 1 == mPositions[0] }
                              onChange={handleMPositionsChange}
                            />
                            <Form.Check
                              inline
                              label="副理事長"
                              type="checkbox"
                              name="mPositions1"
                              value="1"
                              checked={ 1 == mPositions[1] }
                              onChange={handleMPositionsChange}
                            />
                            <Form.Check
                              inline
                              label="理事"
                              type="checkbox"
                              name="mPositions2"
                              value="1"
                              checked={ 1 == mPositions[2] }
                              onChange={handleMPositionsChange}
                            />
                            <Form.Check
                              inline
                              label="監事"
                              type="checkbox"
                              name="mPositions3"
                              value="1"
                              checked={ 1 == mPositions[3] }
                              onChange={handleMPositionsChange}
                            />
                            <Form.Check
                              inline
                              label="委員長"
                              type="checkbox"
                              name="mPositions4"
                              value="1"
                              checked={ 1 == mPositions[4] }
                              onChange={handleMPositionsChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr className="">
                        <th>委員会（正会員）</th>
                        <td>
                          <Form.Group size="lg">
                           <Form.Check
                              inline
                              label="総務委員会"
                              type="checkbox"
                              name="mCommittees0"
                              value="1"
                              checked={ 1 == mCommittees[0] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="財務委員会"
                              type="checkbox"
                              name="mCommittees1"
                              value="1"
                              checked={ 1 == mCommittees[1] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="学術委員会"
                              name="mCommittees2"
                              type="checkbox"
                              value="1"
                              checked={ 1 == mCommittees[2] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="編集委員会"
                              type="checkbox"
                              name="mCommittees3"
                              value="1"
                              checked={ 1 == mCommittees[3] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="教育研修委員会"
                              type="checkbox"
                              name="mCommittees4"
                              value="1"
                              checked={ 1 == mCommittees[4] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="資格審査委員会"
                              type="checkbox"
                              name="mCommittees5"
                              value="1"
                              checked={ 1 == mCommittees[5] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="倫理・COI委員会"
                              type="checkbox"
                              name="mCommittees6"
                              value="1"
                              checked={ 1 == mCommittees[6] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="オリンピック・パラリンピック等準備委員会"
                              type="checkbox"
                              name="mCommittees7"
                              value="1"
                              checked={ 1 == mCommittees[7] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="国際委員会"
                              type="checkbox"
                              name="mCommittees8"
                              value="1"
                              checked={ 1 == mCommittees[8] }
                              onChange={handleMCommitteesChange}
                            />
                            <Form.Check
                              inline
                              label="広報委員会"
                              type="checkbox"
                              name="mCommittees9"
                              value="1"
                              checked={ 1 == mCommittees[9] }
                              onChange={handleMCommitteesChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr className="">
                        <th>代議員（正会員）</th>
                        <td>
                          <Form.Group size="lg">
                            <Form.Check
                              inline
                              label="代議員"
                              name="mRepresentative0"
                              type="checkbox"
                              value="1"
                              checked={ 1 == mRepresentative[0] }
                              onChange={handleMRepresentativeChanges}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>ベーシック領域（正会員）</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="mBasicDomain" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="mBasicDomain"
                              value={fields.mBasicDomain}
                              onChange={handleFieldChange}
                            >
                              <option value="0"></option>
                              { BasicDomainItems.map((item, index) => (
                                  <option value={index+1}>{item}</option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>エキスパート領域（正会員）</th>
                        <td>
                          <Form.Group className="inlineFormControl" controlId="mExpertDomain" size="lg">
                          { ExpertDomainItems.map((item, index) => (
                            <Form.Check
                              inline
                              id={ 'expertDomainChecks'+index }
                              name={ 'expertDomainChecks'+index }
                              label={item}
                              type="checkbox"
                              value="1"
                              checked={ mExpertDomainChecks[index] == 1 }
                              onChange={handleExpertDomainChecksChange}
                            />
                          ))}
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>主としてサポートしている競技の分類（正会員）</th>
                        <td>
                          <Form.Group className="inlineFormControl" controlId="mPrimaryGames" size="lg">
                          { PrimaryGamesItems.map((item, index) => (
                            <Form.Check
                              custom
                              id={ 'primaryGamesChecks'+index }
                              name={ 'primaryGamesChecks'+index }
                              label={item}
                              type="checkbox"
                              value="1"
                              checked={ mPrimaryGamesChecks[index] == 1 }
                              onChange={handlePrimaryGamesChecksChange}
                            />
                          ))}
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>取得スポーツ医資格（正会員）</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="mCert1Selects" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="mCert1Selects"
                              value={fields.mCert1Selects}
                              onChange={handleFieldChange}
                            >
                              <option value="0"></option>
                              <option value="1">日本スポーツ協会公認スポーツドクター</option>
                              <option value="2">日本整形外科学会認定スポーツ医</option>
                              <option value="3">日本医師会健康スポーツ医</option>
                              <option value="4">日本障がい者スポーツ協会障がい者スポーツ医</option>
                              <option value="5">日本スポーツ協会公認スポーツデンティスト</option>
                              <option value="6">なし</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>学位（准会員）</th>
                        <td>
                          <Form.Group controlId="mDegree" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mDegree}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>資格・身分（准会員）</th>
                        <td>
                          <Form.Group size="lg">
                          { Cert2CheckItems.map(({label, idx}, index) => (
                            <Form.Check
                              inline
                              id={ "mCert2Checks" + idx }
                              name={ "mCert2Checks" + idx }
                              label={label}
                              type="checkbox"
                              value={1}
                              checked={ 1 == mCert2Checks[idx] }
                              onChange={handleCert2ChecksChange}
                            />
                          ))}
                          </Form.Group>
                        </td>
                      </tr>
                      <tr className="admHidden">
                        <th>年会費</th>
                        <td>
                          <Form.Group className="inlineFormControl">
                            <Form.Check
                              inline
                              id="mAnnualFees0"
                              name="mAnnualFees0"
                              label="未入金"
                              type="checkbox"
                              value="1"
                              checked={ 1 == mAnnualFees[0] }
                              onChange={handleMAnnualFeesChange}
                              className="inlineFormControl"
                            />
                            <Form.Check
                              inline
                              id="mAnnualFees1"
                              name="mAnnualFees1"
                              label="入金済"
                              type="checkbox"
                              value="1"
                              checked={ 1 == mAnnualFees[1] }
                              onChange={handleMAnnualFeesChange}
                              className="inlineFormControl"
                            />
                          </Form.Group>
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sYearOfFee" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sYearOfFee"
                              value={fields.sYearOfFee}
                              onChange={handleFieldChange}
                            >
                              <option value="0000"></option>
                              <option value="1990">1990</option>
                              <option value="1991">1991</option>
                              <option value="1992">1992</option>
                              <option value="1993">1993</option>
                              <option value="1994">1994</option>
                              <option value="1995">1995</option>
                              <option value="1996">1996</option>
                              <option value="1997">1997</option>
                              <option value="1998">1998</option>
                              <option value="1999">1999</option>
                              <option value="2000">2000</option>
                              <option value="2001">2001</option>
                              <option value="2002">2002</option>
                              <option value="2003">2003</option>
                              <option value="2004">2004</option>
                              <option value="2005">2005</option>
                              <option value="2006">2006</option>
                              <option value="2007">2007</option>
                              <option value="2008">2008</option>
                              <option value="2009">2009</option>
                              <option value="2010">2010</option>
                              <option value="2011">2011</option>
                              <option value="2012">2012</option>
                              <option value="2013">2013</option>
                              <option value="2014">2014</option>
                              <option value="2015">2015</option>
                              <option value="2016">2016</option>
                              <option value="2017">2017</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr key="sPrefectures">
                      <th>都道府県</th>
                        <td>
                          <Form.Group controlId="mPrefecture" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="mPrefecture"
                              value={fields.mPrefecture}
                              onChange={handleFieldChange}
                            >
<option value="" selected>都道府県選択...</option>
<option value="北海道">北海道</option>
<option value="青森県">青森県</option>
<option value="岩手県">岩手県</option>
<option value="宮城県">宮城県</option>
<option value="秋田県">秋田県</option>
<option value="山形県">山形県</option>
<option value="福島県">福島県</option>
<option value="茨城県">茨城県</option>
<option value="栃木県">栃木県</option>
<option value="群馬県">群馬県</option>
<option value="埼玉県">埼玉県</option>
<option value="千葉県">千葉県</option>
<option value="東京都">東京都</option>
<option value="神奈川県">神奈川県</option>
<option value="新潟県">新潟県</option>
<option value="富山県">富山県</option>
<option value="石川県">石川県</option>
<option value="福井県">福井県</option>
<option value="山梨県">山梨県</option>
<option value="長野県">長野県</option>
<option value="岐阜県">岐阜県</option>
<option value="静岡県">静岡県</option>
<option value="愛知県">愛知県</option>
<option value="三重県">三重県</option>
<option value="滋賀県">滋賀県</option>
<option value="京都府">京都府</option>
<option value="大阪府">大阪府</option>
<option value="兵庫県">兵庫県</option>
<option value="奈良県">奈良県</option>
<option value="和歌山県">和歌山県</option>
<option value="鳥取県">鳥取県</option>
<option value="島根県">島根県</option>
<option value="岡山県">岡山県</option>
<option value="広島県">広島県</option>
<option value="山口県">山口県</option>
<option value="徳島県">徳島県</option>
<option value="香川県">香川県</option>
<option value="愛媛県">愛媛県</option>
<option value="高知県">高知県</option>
<option value="福岡県">福岡県</option>
<option value="佐賀県">佐賀県</option>
<option value="長崎県">長崎県</option>
<option value="熊本県">熊本県</option>
<option value="大分県">大分県</option>
<option value="宮崎県">宮崎県</option>
<option value="鹿児島県">鹿児島県</option>
<option value="沖縄県">沖縄県</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>ソート順</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="orderBy" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="orderBy"
                              value={fields.orderBy}
                              onChange={handleFieldChange}
                            >
                              <option value="1">会員番号</option>
                            </Form.Control>
                          </Form.Group>
                          の
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="ascOrDesc" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="ascOrDesc"
                              value={fields.ascOrDescy}
                              onChange={handleFieldChange}
                            >
                              <option value="1">降順</option>
                              <option value="2">昇順</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>表示件数</th>
                        <td>
                          <Form.Group className="" controlId="pageLimit" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="pageLimit"
                              value={pageLimit}
                              onChange={handlePageChanged}
                            >
                              <option value="10">10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="search_btn">
                    <Button id="searchBtn" active size="sm" active onClick={ handleSearch }>検索</Button>
                    <Button id="resetBtn" active size="sm" active onClick={ handleClear }>検索条件クリア</Button>
                 </div>
                </div>
　　　　　　　　　<div id="actionblock">
                 <h3>一括処理</h3>
                 <p>リスト一覧でチェックした情報に対して一括処理を行います。</p>
               <Button id="sendMailBtn" active size="sm" active onClick={ handleMail }>メール送信</Button>
               </div>
               <div id="list">
                 <h3>リスト一覧</h3>
            <p>{ parseInt(pageLimit)*(currentPage-1)+1 } - { parseInt(pageLimit)*(currentPage) }を表示中：ページ{currentPage} (全<b>{ total }</b>件中)</p>
                 <Table>
                   <tbody>
                     <tr>
                       <th>
                            <Form.Check
                              inline
                              type="checkbox"
                              name="selectAll"
                              value="1"
                              checked={ 1 == selectAll }
                              onChange={handleItemCheckChanged}
                            />
                       </th>
                       <th>会員番号</th>
                       <th>氏　名</th>
                       <th>所　属</th>
                       <th>会員種別</th>
                       <th>入会日</th>
                       <th className="opButtonCol">処理</th>
                     </tr>
                     <tr>
                     </tr>
          {mmembers.map(({pk,sk,data, familyName, givenName, affiliationName, status, dateOfPayment, admissionDate, memType, memberId}, index) => (
                     <tr>
                       <td>
                            <Form.Check
                              inline
                              type="checkbox"
                              name="memItem"
                              value={index}
                              onChange={handleMTypesChange}
                              checked={1 == checks[index]}                   
                              onChange={handleItemCheckChanged}
                            />
                       </td>
                       <td>
                  { memberId == 'NotAssignedYet' ? '' : memberId }
                       </td>
                       <td>
                  {familyName} {givenName}
                       </td>
                       <td>
                  { affiliationName }
                       </td>
                       <td>
		  {  MemberTypeItemNames[memType] }
                       </td>
                       <td>
                  { admissionDate }
                       </td>
                       <td>
                  <Button id="viewBtn" pk={ pk }  active size="sm" active onClick={ handleView }>詳細</Button>
                  <Button id="editfBtn" pk={ pk }  active size="sm" active onClick={ handleEdit }>編集</Button>
                  { mmembers[index].authStatus == 'Assigned' ? 
                  <Button id={`invitationBtn-${index}`} className="" idx={index}  pk={ pk } size="sm" disabled onClick={ handleInvitation } >招待メール</Button> :
                  <Button id={`invitationBtn-${index}`} className={ mmembers[index].authStatus == 'Invited' ? "Invited" : "" } idx={index}  pk={ pk } size="sm" active onClick={ handleInvitation } >招待メール</Button>     
                  }
                       </td>
                  </tr>
                     ))}
                   </tbody>
                 </Table>
                 <div className="pageswitch">
                    <ul>
          { pages.map(({label}, index) => (
		  <li className={(currentPage == label) ? 'active' : ''}><Nav.Link href={ "#" + label} onClick={pageClickAction}>{label}</Nav.Link></li>
	  ))}
                    </ul>
                  </div>
               </div>
              </section>
    );
  };

  return (
    <div className="Admin">
      <h1 id="page_title">管理者用　会員管理</h1>
      <div className="container">
        <div id="sub_page">
          <div id="admin" className="top">
            <AdminLeftMenu />
	  { renderingState == 'Main' ? renderMain() : (renderingState == 'NewMail' ? renderMail() : (renderingState == 'MailSent' ? renderMailComplete() :  renderMailConfirm())) }
          </div>
        </div>
      </div>
    </div>
  );
}
